import React from "react";
import styled from "styled-components";
import { useLanguage, Language } from "../contexts/LanguageContext";

const SwitcherContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 9;
  display: flex;
  gap: 10px;
  align-items: center;
`;

const LanguageButton = styled.button<{ isActive: boolean }>`
  background: ${(props) =>
    props.isActive ? "#f34452" : "rgba(255, 255, 255, 0.2)"};
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: ${(props) =>
      props.isActive ? "#d63946" : "rgba(255, 255, 255, 0.3)"};
    border-color: #f34452;
    transform: translateY(-2px);
  }

  &:focus {
    outline: 2px solid #f34452;
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    padding: 6px 10px;
    font-size: 12px;
  }
`;

const SwitcherLabel = styled.span`
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  opacity: 0.8;

  @media (max-width: 768px) {
    display: none;
  }
`;

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();

  const handleLanguageChange = (newLanguage: Language) => {
    setLanguage(newLanguage);
  };

  return (
    <SwitcherContainer role="toolbar" aria-label="Language switcher">
      <SwitcherLabel>{t("lang.switchTo")}:</SwitcherLabel>
      <LanguageButton
        isActive={language === "en"}
        onClick={() => handleLanguageChange("en")}
        aria-label={`Switch to English`}
        aria-pressed={language === "en"}
      >
        EN
      </LanguageButton>
      <LanguageButton
        isActive={language === "zh"}
        onClick={() => handleLanguageChange("zh")}
        aria-label={`切换到中文`}
        aria-pressed={language === "zh"}
      >
        中文
      </LanguageButton>
    </SwitcherContainer>
  );
};

export default LanguageSwitcher;
